// extracted by mini-css-extract-plugin
var _1 = "PublicSidebar-module__animateUploadProgressBarWidth--hHWle";
var _2 = "PublicSidebar-module__animatedBackground--CEPig";
var _3 = "PublicSidebar-module__container--ns_7l";
var _4 = "PublicSidebar-module__icon--b0SJs";
var _5 = "PublicSidebar-module__isFloating--bCKQE";
var _6 = "PublicSidebar-module__isScrolled--WNCYH";
var _7 = "PublicSidebar-module__searchBar--B4ctJ";
var _8 = "PublicSidebar-module__searchBarContainer--C3zC9";
var _9 = "PublicSidebar-module__searchIcon--ygNob";
var _a = "PublicSidebar-module__sections--xvwNT";
var _b = "PublicSidebar-module__shortcut--bc8_1";
var _c = "PublicSidebar-module__sidebarToggleButton--irS_B";
var _d = "PublicSidebar-module__sidebarToggleButtonContainer--vaSMl";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "icon", _5 as "isFloating", _6 as "isScrolled", _7 as "searchBar", _8 as "searchBarContainer", _9 as "searchIcon", _a as "sections", _b as "shortcut", _c as "sidebarToggleButton", _d as "sidebarToggleButtonContainer" }
